// src/components/EarlyAccessForm/EarlyAccessForm.jsx
import React, { useState } from 'react';
import './EarlyAccessForm.css';

const FORMSPREE_ENDPOINT = 'https://formspree.io/f/moeaeepl';

const ROLE_OPTIONS = [
  'Dancer',
  'Parent of Dancer',
  'Professional Dancer',
  'Adult Dancer',
  'Dance Studio',
  'Dance Store',
  'Pointe Shoe Company',
  'Physical Therapist',
  'Research Lab',
  'Other',
];

const EarlyAccessForm = ({ idPrefix = 'ea', submitLabel = 'Request Early Access' }) => {
  const [formData, setFormData] = useState({ name: '', email: '', role: '', hopes: '' });
  const [status, setStatus] = useState('idle'); // idle | submitting | success | error

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('submitting');
    try {
      const res = await fetch(FORMSPREE_ENDPOINT, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(e.target),
      });
      if (res.ok) {
        setStatus('success');
        setFormData({ name: '', email: '', role: '', hopes: '' });
      } else {
        setStatus('error');
      }
    } catch (err) {
      setStatus('error');
    }
  };

  if (status === 'success') {
    return <div className="form-success">Thank you! We&rsquo;ll be in touch soon.</div>;
  }

  return (
    <form className="early-access-form" onSubmit={handleSubmit}>
      <div className="form-row">
        <label htmlFor={`${idPrefix}-name`}>Name</label>
        <input
          id={`${idPrefix}-name`}
          name="name"
          type="text"
          required
          value={formData.name}
          onChange={handleChange}
        />
      </div>

      <div className="form-row">
        <label htmlFor={`${idPrefix}-email`}>Email</label>
        <input
          id={`${idPrefix}-email`}
          name="email"
          type="email"
          required
          value={formData.email}
          onChange={handleChange}
        />
      </div>

      <div className="form-row">
        <label htmlFor={`${idPrefix}-role`}>I am a...</label>
        <select
          id={`${idPrefix}-role`}
          name="role"
          required
          value={formData.role}
          onChange={handleChange}
        >
          <option value="" disabled>
            Select one
          </option>
          {ROLE_OPTIONS.map((role) => (
            <option key={role} value={role}>
              {role}
            </option>
          ))}
        </select>
      </div>

      <div className="form-row">
        <label htmlFor={`${idPrefix}-hopes`}>What are you hoping PointeSense can help you with? (optional)</label>
        <textarea
          id={`${idPrefix}-hopes`}
          name="hopes"
          rows={3}
          value={formData.hopes}
          onChange={handleChange}
        />
      </div>

      <button type="submit" className="early-access-button" disabled={status === 'submitting'}>
        {status === 'submitting' ? 'Sending...' : submitLabel}
      </button>

      {status === 'error' && (
        <p className="form-error">Something went wrong. Please try again or email us directly.</p>
      )}

      <p className="privacy-note">We&rsquo;ll never share your information.</p>
    </form>
  );
};

export default EarlyAccessForm;
